<template>
  <tr :class="{'clickable': $can('edit', 'YachtEngine')}">
    <td>
      {{ yachtEngine.manufacturer }}
    </td>
    <td>
      {{ yachtEngine.model }}
    </td>
    <td>
      {{ yachtEngine.power }} HP
    </td>
  </tr>
</template>

<script>
  export default {
    name: 'YachtEngineRow',
    props: {
      yachtEngine: {
        type: Object,
        default: null
      }
    }
  }
</script>
